(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["recently-viewed-products"] && !Shopify.designMode) return;
  try {
    class RecentlyViewedProducts extends HTMLElement {
  connectedCallback() {
    this.storageKey = 'recently_viewed_handles';
    this.limit = parseInt(this.dataset.limit, 10) || 8;
    this.currentHandle = this.dataset.handle || '';
    this.rootUrl = this.dataset.rootUrl || '/';
    this.currency = this.dataset.currency || 'USD';
    this.locale = this.dataset.locale || document.documentElement.lang || 'en';

    this.grid = this.querySelector('.rv__grid');
    this.emptyEl = this.querySelector('.rv__empty');
    this.modalOverlay = this.querySelector('.rv__modal-overlay');
    this.modalLoadingEl = this.querySelector('.rv__modal-loading');
    this.modalBodyEl = this.querySelector('.rv__modal-body');
    this.productsByHandle = new Map();
    this.quickAddHtmlCache = new Map();

    try {
      this.formatter = new Intl.NumberFormat(this.locale, {
        style: 'currency',
        currency: this.currency,
      });
    } catch (e) {
      this.formatter = null;
    }

    this.addCurrent();
    this.render();

    // Card quick-add button opens the modal with Shopify's own real
    // quick-add markup (image gallery, variant picker, add to cart).
    this.grid.addEventListener('click', (event) => {
      const button = event.target.closest('.rv__quick-add');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      this.openQuickAddModal(button.dataset.productHandle);
    });

    // Modal only needs to handle closing — everything inside .rv__modal-body
    // is Horizon's own markup, driven by Horizon's own custom elements.
    if (this.modalOverlay) {
      this.modalOverlay.addEventListener('click', (event) => {
        if (event.target === this.modalOverlay || event.target.closest('.rv__modal-close')) {
          this.closeQuickAddModal();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !this.modalOverlay.hidden) {
          this.closeQuickAddModal();
        }
      });
    }
  }

  getStorage() {
    try {
      const raw = window.localStorage.getItem(this.storageKey);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  saveStorage(items) {
    try {
      window.localStorage.setItem(this.storageKey, JSON.stringify(items));
    } catch (e) {
      // localStorage unavailable (private browsing, quota exceeded, etc).
      // Fail silently rather than breaking the page.
    }
  }

  addCurrent() {
    if (!this.currentHandle) return;

    let items = this.getStorage().filter((handle) => handle !== this.currentHandle);
    items.unshift(this.currentHandle);
    items = items.slice(0, this.limit);

    this.saveStorage(items);
  }

  async fetchProduct(handle) {
    try {
      const response = await fetch(`${this.rootUrl}products/${handle}.js`);
      if (!response.ok) return null;
      return await response.json();
    } catch (e) {
      return null;
    }
  }

  formatMoney(cents) {
    const amount = (cents || 0) / 100;
    if (this.formatter) return this.formatter.format(amount);
    return `${this.currency} ${amount.toFixed(2)}`;
  }

  escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  // Reads the product's tags and returns which badge (if any) should show
  // on the image. Looks for tags like "Best Seller" / "Bestseller" or "New".
  getTagBadge(product) {
    const tags = (product.tags || []).map((tag) => String(tag).toLowerCase().replace(/\s+/g, ''));

    if (tags.some((tag) => tag.includes('bestseller') || tag.includes('best-seller'))) {
      return 'Best Seller';
    }
    if (tags.some((tag) => tag === 'new' || tag.includes('newarrival') || tag.includes('new-arrival'))) {
      return 'New';
    }
    return null;
  }

  // Builds the sale price / compare-at price / discount % markup. Sale
  // price is shown first, compare-at price after it (struck through).
  priceMarkup(price, compareAtPrice) {
    const hasCompare = compareAtPrice && compareAtPrice > price;
    const saleHtml = `<strong class="rv__sale-price">${this.formatMoney(price)}</strong>`;
    const compareHtml = hasCompare
      ? `<span class="rv__compare-price">${this.formatMoney(compareAtPrice)}</span>`
      : '';

    let discountHtml = '';
    if (hasCompare) {
      const discountPercent = Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
      discountHtml = `<span class="rv__discount-badge">${discountPercent}% OFF</span>`;
    }

    return `${saleHtml}${compareHtml}${discountHtml}`;
  }

  // Fetches the product page and pulls out Horizon's own quick-add markup
  // (image gallery, variant picker, quantity selector, add-to-cart button —
  // all wired up by Horizon's own custom elements already loaded on the
  // page). Falls back to the whole <product-component> if the theme's
  // specific quick-add wrapper id/class isn't found.
  async fetchQuickAddHtml(handle) {
    if (this.quickAddHtmlCache.has(handle)) {
      return this.quickAddHtmlCache.get(handle);
    }

    const response = await fetch(`${this.rootUrl}products/${handle}`);
    if (!response.ok) return null;

    const pageHtml = await response.text();
    const doc = new DOMParser().parseFromString(pageHtml, 'text/html');

    const node =
      doc.querySelector('#quick-add-modal-content') ||
      doc.querySelector('.quick-add-modal__content') ||
      doc.querySelector('product-component');

    const html = node ? node.outerHTML : null;
    this.quickAddHtmlCache.set(handle, html);
    return html;
  }

  async openQuickAddModal(handle) {
    if (!handle || !this.modalOverlay) return;

    this.modalOverlay.hidden = false;
    document.body.style.overflow = 'hidden';

    if (this.modalLoadingEl) this.modalLoadingEl.hidden = false;
    if (this.modalBodyEl) this.modalBodyEl.innerHTML = '';

    try {
      const html = await this.fetchQuickAddHtml(handle);

      // The user may have closed the modal while this was loading.
      if (this.modalOverlay.hidden) return;

      if (this.modalLoadingEl) this.modalLoadingEl.hidden = true;

      if (html && this.modalBodyEl) {
        this.modalBodyEl.innerHTML = html;
      } else if (this.modalBodyEl) {
        this.modalBodyEl.innerHTML = '<p>Sorry, this product could not be loaded.</p>';
      }
    } catch (error) {
      if (this.modalLoadingEl) this.modalLoadingEl.hidden = true;
      if (this.modalBodyEl) {
        this.modalBodyEl.innerHTML = '<p>Sorry, this product could not be loaded.</p>';
      }
    }
  }

  closeQuickAddModal() {
    if (!this.modalOverlay) return;
    this.modalOverlay.hidden = true;
    document.body.style.overflow = '';
    if (this.modalBodyEl) this.modalBodyEl.innerHTML = '';
  }

  async render() {
    if (!this.grid) return;

    const handles = this.getStorage().filter((handle) => handle !== this.currentHandle);

    if (handles.length === 0) {
      if (this.emptyEl) this.emptyEl.hidden = false;
      return;
    }

    const products = await Promise.all(handles.map((handle) => this.fetchProduct(handle)));
    const validProducts = products.filter(Boolean);

    if (validProducts.length === 0) {
      if (this.emptyEl) this.emptyEl.hidden = false;
      return;
    }

    if (this.emptyEl) this.emptyEl.hidden = true;

    this.productsByHandle = new Map(validProducts.map((product) => [product.handle, product]));
    this.grid.innerHTML = validProducts.map((product) => this.renderCard(product)).join('');
  }

  renderCard(product) {
    const title = this.escapeHtml(product.title);
    const url = `${this.rootUrl}products/${this.escapeHtml(product.handle)}`;
    const image = product.featured_image ? this.escapeHtml(product.featured_image) : '';

    // Best seller / New badge shown over the image
    const tagBadge = this.getTagBadge(product);
    const tagBadgeHtml = tagBadge ? `<span class="rv__tag-badge">${tagBadge}</span>` : '';

    const imageHtml = image
      ? `<img src="${image}" alt="${title}" loading="lazy">`
      : '';

    // Quick add button — opens the quick-add modal for this product
    // (variant picker + Add button), same as Horizon's product card.
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const availableVariant = variants.find((variant) => variant.available) || variants[0];
    const soldOut = !availableVariant || !availableVariant.available;

    const quickAddHtml = `
      <button
        class="button quick-add__button quick-add__button--choose add-to-cart-button rv__quick-add"
        type="button"
        name="add"
        on:click="quick-add-component/handleClick"
        data-product-handle="${this.escapeHtml(product.handle)}"
        aria-label="Add ${title} to cart"
        ${soldOut ? 'disabled' : ''}
      >
        <span class="add-to-cart-text">
          
          <span aria-hidden="true" class="svg-wrapper add-to-cart-icon"><svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="var(--icon-stroke-width)" d="M16.608 9.421V6.906H3.392v8.016c0 .567.224 1.112.624 1.513.4.402.941.627 1.506.627H8.63M8.818 3h2.333c.618 0 1.212.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.344c0-.622.246-1.218.683-1.658A2.33 2.33 0 0 1 8.82 3"></path><path stroke="currentColor" stroke-linecap="round" stroke-width="var(--icon-stroke-width)" d="M14.608 12.563v5m2.5-2.5h-5"></path></svg>
</span>
          <span class="add-to-cart-text__content is-visually-hidden-mobile">
            <span>
              
              <span>
                Choose
              </span>
            </span>
          </span>
        </span>
      </button>
    `;

    return `
      <div class="rv__card" role="listitem">
        <div class="rv__image-wrap">
          ${tagBadgeHtml}
          <a href="${url}" class="rv__image-link" aria-label="${title}">
            ${imageHtml}
          </a>
          ${quickAddHtml}
        </div>
        <a href="${url}" class="rv__content-link">
          <div class="rv__content">
            <p class="rv__title">${title}</p>
            <div class="rv__price-wrap">
              ${this.priceMarkup(product.price, product.compare_at_price)}
            </div>
          </div>
        </a>
      </div>
    `;
  }
}

if (!customElements.get('recently-viewed-products')) {
  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
  } catch(e) { console.error(e); }
})();

})();
